<template><div><h1>开始使用 VUX 之前</h1>
<div class="warning">
<p>如果你刚从后端转到前端，可能会被目前前端(表面的)工程复杂度惊吓到，但是放心，使用 <code>vue-cli</code> 从模板创建项目可以快速开始编码、构建，仅仅是几行简单的命令不是么？</p>
</div>
<p>在使用 VUX 之前需要你至少已经会使用 <code>Vue</code>，同时需要你大概了解 <code>Node.js</code>，<code>npm</code>，<code>cnpm</code>，<code>yarn</code> 这些东西。</p>
<div class="tip">
<p>建议 <code>Node.js</code> 版本在 <code>7.6.0</code> 以上。</p>
</div>
<h2>相关工具</h2>
<h3>WeUI</h3>
<p>VUX 样式基于 <a href="https://github.com/weui/weui">WeUI</a>，但是你不必通过使用 VUX 来使用 <code>WeUI</code>。简单的页面你可以直接引入 <code>WeUI</code> 样式。详细请参考 <a href="https://github.com/weui/weui">WeUI 文档</a>。</p>
<h3>Vue</h3>
<p>VUX 基于 <code>Vue</code> 的组件库，意味着你需要有 <code>Vue</code> 的基础知识。</p>
<p>如果还没有了解过，建议先看看<a href="https://cn.vuejs.org">Vue 官方文档</a>。</p>
<h3>Webpack</h3>
<p>如果你直接使用 <code>vux2</code> 模板，你可以暂时不用了解。当你需要自定义一些配置时自然就能很快了解了。</p>
<p><a href="https://webpack.js.org">Webpack 文档</a></p>
<h3>vue-cli</h3>
<p>Vue 官方用于快速创建项目的工具。</p>
<pre class="hljs"><code>npm install vue-cli -g
</code></pre>
<p>或者使用 yarn</p>
<pre class="hljs"><code>yarn global add vue-cli
</code></pre>
<p><a href="https://github.com/vuejs/vue-cli">vue-cli 文档</a></p>
<h3>vue-loader</h3>
<p>webpack loader，用于编译 <code>.vue</code> 文件，官方模板已经帮你配置好。</p>
<p><a href="https://vue-loader.vuejs.org">vue-loader 文档</a></p>
<h3>vux-loader</h3>
<p>VUX 组件库的 webpack loader，实现按需加载等功能。它不是替代 <code>vue-loader</code> 而是配合 <code>vue-loader</code> 使用。如果你使用 vux2 模板，暂不需要手动使用它。</p>
</div></template><script>
export default {
  head: {"title":"开始使用 VUX 之前 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// before-using-vux-57.vue?62477493